<template lang="pug">
    #Demonstracoes
        .container
            ul
                li(v-for="item in items")
                    a(:href="item.file" :download="item.downloadName" target="_blank")
                        .img
                            img(:src="item.image").image
                            .flip
                                p.data {{ item.year }}
</template>
 
<script>
import { props } from '@/mixins/component';

export default {
    name: "demonstracoes",
    props,

    data () {
        return {
            items: this.contents.content.map((item) => {
                return {
                    file: `${process.env.VUE_APP_API_ROUTE}/files/download/${item.file.fileName}`,
                    image: item.image,
                    year: item.year,
					downloadName: item.file.originalName
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped src="./Demonstracoes.styl"></style>
